/**
 * Public marketing-site origin for canonical URLs, Open Graph, and JSON-LD.
 * Never use the API/backend URL here — crawlers need the URL users see in the browser.
 */
export function getSiteOrigin() {
  if (
    typeof window !== "undefined" &&
    window.location?.origin &&
    window.location.origin !== "null"
  ) {
    return window.location.origin.replace(/\/$/, "");
  }
  const raw =
    process.env.REACT_APP_SITE_ORIGIN ||
    process.env.REACT_APP_PUBLIC_URL ||
    "https://phanerooventures.com";
  return String(raw).replace(/\/$/, "");
}
